import React, { useEffect } from 'react';
import { observer, useLocalStore } from 'mobx-react';
import { Page } from '../../components/atoms/layout/Page';
import { PageHeader } from '../../components/atoms/layout/PageHeader';
import { useNavigation } from '../../components/hocs/withNavigation';
import { NavigationSpecs } from '../../states/NavigationState';
import { NotificationDeliveryListState } from './NotificationDeliveryListState';
import { NotificationDeliveryListItem } from './NotificationDeliveryListItem';
import './notificationDeliveryListPage.module.scss';
import { LoadMoreButton } from '../../../commonv3/components/atoms/buttons/LoadMoreButton';
import { InfiniteScroll } from '../../../commonv3/components/atoms/scroll/InfiniteScroll';
import { LoaderRow } from '../../components/atoms/layout/LoaderRow';
import { restrictAccessForUser } from '../../../commonv3/hooks/restrictAccessForUser';

export const NotificationDeliveryListPage = observer(() => {
    restrictAccessForUser();
    useNavigation(NavigationSpecs.home('white'), NavigationSpecs.standard());

    const { pageState } = useLocalStore(() => ({
        pageState: new NotificationDeliveryListState(),
    }));

    useEffect(() => {
        pageState.init();
    }, []);

    const totalPages = pageState.totalPages;

    // nextPageを読み込むたびにloaderが出るとチカチカするため、最初のみ表示する
    if (totalPages.length === 0 && pageState.loading) {
        return <LoaderRow />;
    }

    return (
        <Page styleName="notification-list-page" id="notification-list-page">
            <PageHeader title="MESSAGE" subTitle="お知らせ" showOnMobile={true} />
            {totalPages && (
                <div styleName="page-body">
                    <div styleName="notification-list-items" data-value="notification-list-items">
                        {totalPages.map((notificationDeliveries) =>
                            notificationDeliveries.map((notificationDelivery) => (
                                <NotificationDeliveryListItem
                                    key={notificationDelivery.id}
                                    notificationDelivery={notificationDelivery}
                                />
                            ))
                        )}
                    </div>
                    {pageState.hasNextPage &&
                        (totalPages.length === 1 ? (
                            <LoadMoreButton loading={pageState.loading} fetchNextPage={pageState.fetchNextPage} />
                        ) : (
                            <InfiniteScroll loading={pageState.loading} fetchNextPage={pageState.fetchNextPage} />
                        ))}
                </div>
            )}
        </Page>
    );
});
